export default __webpack_public_path__ + "static/media/mergeAccountsIcon.ba2bb2bd.svg";